import { Image } from '@cian/ui-kit/image';
import * as React from 'react';

import * as styles from './CardThumbnails.css';
import { IFavoriteEntityMedia } from '../../../../../types/results';

export interface ICardThumbnailsProps {
  media: IFavoriteEntityMedia[];
}

export const CardThumbnails: React.FC<ICardThumbnailsProps> = ({ media }) => {
  return (
    <div className={styles['container']} data-name="CardGalleryThumbnails" data-testid="CardGalleryThumbnails">
      {media.map((item, index) => (
        <div key={`thumbnail_${index}`} className={styles['thumbnail']}>
          <Image src={item.previewUrl} alt="ЖК" objectFit="cover" borderRadius={0} loading="lazy" preloader={false} />
        </div>
      ))}
    </div>
  );
};
